import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import "../styles/DashboardLayout.css";

function titleForPath(pathname) {
  if (pathname === "/" || pathname === "") return "Dashboard";
  if (pathname.startsWith("/posts/create")) return "Create Post";
  if (pathname.startsWith("/posts/edit")) return "Edit Post";
  if (pathname.startsWith("/posts/view")) return "Post Details";
  if (pathname.startsWith("/posts")) return "Posts";
  if (pathname.startsWith("/categories/create")) return "Create Category";
  if (pathname.startsWith("/categories/edit")) return "Edit Category";
  if (pathname.startsWith("/categories")) return "Categories";
  return "Dashboard";
}

export default function DashboardLayout() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  return (
    <div className="layout">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="layout-main">
        <Navbar
          title={titleForPath(location.pathname)}
          onMenuClick={() => setSidebarOpen(true)}
        />
        <main className="layout-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
